module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-451.100707f.woff2";